import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import {
    DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
    DropdownMenuLabel, DropdownMenuItem, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

const TRUST_LEGAL = [
    { label: "Plan & Billing",               to: "/settings/billing" },
    { label: "Privacy & Data",               to: "/privacy-data" },
    { label: "Trust & Legal Centre",         to: "/trust" },
    { label: "Security Centre",              to: "/security" },
    { label: "Privacy Centre",               to: "/privacy-centre" },
    { label: "Terms of Service",             to: "/terms" },
    { label: "Privacy Policy",               to: "/privacy" },
    { label: "Cookie Preferences",           to: "/cookies" },
    { label: "Subscription & Billing Terms", to: "/billing-terms" },
    { label: "Refund & Cancellation Policy", to: "/refund-policy" },
    { label: "Financial Disclaimer",         to: "/financial-disclaimer" },
    { label: "AI & Automated Insights",      to: "/ai-disclosure" },
    { label: "Accessibility",                to: "/accessibility" },
    { label: "Subprocessors",                to: "/subprocessors" },
    { label: "System Status",                to: "/status" },
    { label: "Grievance Redressal",          to: "/grievance" },
    { label: "Report a Vulnerability",       to: "/security/report-vulnerability" },
    { label: "Support",                      to: "/support" },
];

export default function TrustLegalMenu() {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                data-testid="trust-legal-menu-btn"
                aria-label="Trust and legal"
                className="inline-flex items-center gap-1.5 text-xs font-medium text-stone-600 hover:text-stone-900 rounded-md px-2 py-1.5 hover:bg-stone-100 dark:hover:bg-stone-800 dark:text-stone-300 dark:hover:text-stone-50"
            >
                <ShieldCheck size={13} /> Trust &amp; Legal
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-64" data-testid="trust-legal-menu">
                <DropdownMenuLabel>Trust &amp; Legal</DropdownMenuLabel>
                <DropdownMenuSeparator />
                {TRUST_LEGAL.map((l) => (
                    <DropdownMenuItem key={l.to} asChild>
                        <Link to={l.to} data-testid={`tl-${l.to.replace(/\//g, "-")}`}>{l.label}</Link>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
